import React from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import TransportTypeImage from './TransportTypeImage';
import { IOrderState, ITransportState, useAppState } from '../../states/app-state';
import styles from './TransportsCompact.module.scss'; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer

const TransportsCompact: React.FC<{ transport: ITransportState, selectedOrder: IOrderState }> = observer(({ transport, selectedOrder }) => {

    const isDisabled = transport.isDisabled;
    // added by Bearer Web Developer start
    const appState = useAppState();
    const { order } = appState.selectedOrder!.payment;
    const realPrice = order?.selectedTransportOption?.price;
    const discountedPrice = order?.discount.value?.transport_receivable_price; // added by Bearer Web Developer
    const originalPrice = appState.selectedOrder?.transport?.value?.transport_original_price; // added by Bearer Web Developer
    const showRealPrice = !(discountedPrice && (Number(discountedPrice) > Number(originalPrice))); // added by Bearer Web Developer
    const madeOfTransport = selectedOrder.transportOptions.selectedOption!;
    const capitalizeFirstLetterMadeOfTransport = madeOfTransport?.slice(0, 1).toLocaleUpperCase() + madeOfTransport?.slice(1).toLocaleLowerCase();
    const best_fit = selectedOrder?.transportOptions?.selectedOption && selectedOrder?.transportOptions?.selectedOption === selectedOrder?.recommend_vehicle // added by Bearer Web Developer
    // added by Bearer Web Developer end
    // modified by Bearer Web Developer start
    
    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <h2 className={styles.transport}>Mode of Transport</h2>
            </div>
            {
                selectedOrder.transportOptions.selectedOption &&
                <div className={styles.transport_description} style={{ paddingBottom: isDisabled ? "18px" : "0px" }}> {/* style added by Bearer Web Developer */}
                    <div>
                        <TransportTypeImage type={selectedOrder.transportOptions.selectedOption} />
                        <div className={styles.type}>
                            <h3 className={''}>{capitalizeFirstLetterMadeOfTransport}</h3>
                            {/* the following line for best_fit added by Bearer Web Developer */}
                            {best_fit && <img src="/best-fit.svg" alt="" width={46} height={12} />}
                        </div>
                    </div>
                    {/* added by Bearer Web Developer start */}
                    <div>
                        <h4 className={''}>{order?.selectedTransportOption?.time}</h4>
                        {showRealPrice && <h5 className={''}>${realPrice}</h5>}
                    </div>
                    {/* added by Bearer Web Developer end */}
                </div>
            }
            {
                !isDisabled && // !appState?.selectedOrder?.selectedReservedOrder && // selectedReservedOrder added and later removed for individual by Bearer Web Developer
                <div className={styles.edit_part}>
                    <Button variant="text" onClick={() => {
                        if (order?.autoSelectTransport) order?.setAutoSelectTransport(false); // added by Bearer Web Developer
                        transport.setEditing(true)
                    }}>
                        <img src="/expand_more_black.png" alt="" width={24} height={24} />
                    </Button>
                </div>
            }
        </div>
    );
    // modified by Bearer Web Developer end
})
export default TransportsCompact;


